// import { WrappedUserDetailPage } from './lib/UserDetail';
import { WrappedUserDetailPage } from './lib/UserDetail2';
export * from './lib/components';
export default WrappedUserDetailPage;
